import { ContextStore } from 'bernie-plugin-mobx';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';

import { CustomJourneyCriterias } from '@gc/global-components/dist/esm/components/common/header/custom-journey-criterias-types';
import { GlobalNavigationLineOfBusiness } from '__generated__/api/types';
import { MarketingChannels } from 'constants/marketing-channels';

import { Header as HeaderBernie } from '@gc/global-components';

export interface HeaderProps {
  className?: string;
}

export const Header: React.FunctionComponent<HeaderProps> = ({ className }) => {
  const searchCriteria = useSearchCriteriaContext();
  const context = usePlatformContext();

  return (
    <ErrorBoundary label="hotel.bernie.header">
      <HeaderBernie
        className={className}
        lineOfBusiness={GlobalNavigationLineOfBusiness.HOTEL}
        customJourneyCriterias={customJourneyCriterias(searchCriteria) as CustomJourneyCriterias}
        marketing={customGoogleMarketingCriteria(context, searchCriteria)}
      />
    </ErrorBoundary>
  );
};
Header.displayName = 'Header';

const customJourneyCriterias = (searchCriteria?: SearchCriteriaModel) => {
  let customJourneyCriteria;
  const { regionId, startDate, endDate } = searchCriteria || {};
  if (Number(regionId)) {
    customJourneyCriteria = [
      {
        destination: {
          regionId: regionId,
        },
        dateRange: {
          startDate: startDate,
          endDate: endDate,
        },
      },
    ];
  }

  return customJourneyCriteria;
};

const customGoogleMarketingCriteria = (context?: ContextStore, searchCriteria?: SearchCriteriaModel) => {
  const adaptedSearchCriteriaSelections =
    context && searchCriteria && adaptSearchCriteria(context, searchCriteria, false)?.secondary?.selections;

  const gclid = adaptedSearchCriteriaSelections?.find(selection => selection.id.toLowerCase() === MarketingChannels.gclid)?.value;
  const mdpdtl = adaptedSearchCriteriaSelections?.find(selection => selection.id.toLowerCase() === MarketingChannels.mdpdtl)?.value;

  return {
    metaDistributionPartnersDetails: mdpdtl,
    googleClickIdentifier: gclid,
  };
};
